import baseApi from './base.api'
import { createTagsForList, OVERRULE_REASONING_TAG } from './utils/tags'

export const overruleReasoningApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchOverruleReasonings: builder.query({
            query: ({ token, layerId, motifId }) => ({
                url: `/criterion-few-shot-examples/${token}/${layerId}`,
                method: 'GET',
                params: { motif_id: motifId },
            }),
            transformResponse: response => ({
                items: response.examples || [],
            }),
            providesTags: result => createTagsForList(result.items, OVERRULE_REASONING_TAG),
        }),
        createOverruleReasoning: builder.mutation({
            query: ({ token, layerId, fileId, motifId, criterionIx, criterionMet, reasoning }) => ({
                url: `/criterion-few-shot-examples/${token}`,
                method: 'POST',
                data: {
                    file_id: fileId,
                    motif_id: motifId,
                    criterion_ix: criterionIx,
                    criterion_met: criterionMet,
                    reasoning,
                    layer_id: layerId,
                },
            }),
            invalidatesTags: [{ type: OVERRULE_REASONING_TAG, id: 'LIST' }],
        }),
        updateOverruleReasoning: builder.mutation({
            query: ({ id, criterionMet, reasoning }) => ({
                url: `/criterion-few-shot-examples/${id}`,
                method: 'PATCH',
                data: {
                    criterion_met: criterionMet,
                    reasoning,
                },
            }),
            invalidatesTags: (result, error, { id }) => [{ type: OVERRULE_REASONING_TAG, id }],
        }),
        deleteOverruleReasoning: builder.mutation({
            query: ({ id }) => ({
                url: `/criterion-few-shot-examples/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: OVERRULE_REASONING_TAG, id: 'LIST' }],
        }),
    }),
})

export const {
    useFetchOverruleReasoningsQuery,
    useCreateOverruleReasoningMutation,
    useUpdateOverruleReasoningMutation,
    useDeleteOverruleReasoningMutation,
} = overruleReasoningApi 